import * as _ from "lodash";
import * as React from "react";
import styled, { css } from "styled-components";
import { observer } from "mobx-react";
import { MainStore } from "app/stores/mainStore";
import { QwiltHighchart } from "app/components/qwiltHighchart/QwiltHighchart";
import { LoadingSpinner } from "app/components/loadingSpinner/LoadingSpinner";
import { MetricCard } from "app/components/metricCard/MetricCard";
import { FallbackContainer } from "app/components/wallBoard/WallBoard";
import { UnitKindEnum, unitsFormatter } from "app/utils/unitsFormatter";
import QwiltLogo from "app/components/QwiltLogo";

const qwiltLogo = require("app/images/qwilt.png");

const Header = styled.div`
  ${(props: {}) => css`
    display: flex;
    align-items: center;
    width: 100%;
  `};
`;

const Title = styled.span`
  ${(props: {}) => css`
    text-transform: uppercase;
    font-size: 48px;
    margin: 10px;
    color: white;
  `};
`;

const SubTitle = styled.span`
  ${(props: {}) => css`
    text-transform: uppercase;
    font-size: 32px;
    margin: 10px;
    opacity: 0.8;
    color: white;
  `};
`;

const ChartContainer = styled.div`
  ${(props: {}) => css`
    position: relative;
    width: 100%;
    min-height: 30vh;
    max-height: 50vh;
  `};
`;
const LoadingMessage = styled.span`
  ${(props: {}) => css`
    color: #bdff00;
  `};
`;

const MetricPanels = styled.div`
  ${(props: {}) => css`
    display: flex;
    justify-content: space-evenly;
    flex: 1 1 auto;
    align-items: center;
    justify-self: stretch;
    background-color: transparent;
    margin-top: 5px;
  `};
`;

const MetricsPanelView = styled.div`
  ${(props: {}) => css`
    background-color: #022e3f;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    grid-column: span 4;
    justify-self: stretch;
  `};
`;

export interface Props {
  store: MainStore;

  className?: string;
}
export type DefaultPropsKeys = never;

const initialState = {};

type State = Readonly<typeof initialState>;

@observer
export class MetricsPanel extends React.Component<Props, State> {
  static defaultProps: Pick<Props, DefaultPropsKeys> = {};
  readonly state: State = initialState;

  render() {
    const { store } = this.props;

    const isBandwidthReady = !!(store.bandwidthHistogram && store.bandwidthHistogram.peakValue);
    const peakBandwidthValue = unitsFormatter.format(
      isBandwidthReady ? store.bandwidthHistogram!.peakValue!.y : 0,
      UnitKindEnum.TRAFFIC
    );

    const totalVolumeValue = unitsFormatter.format(
      store.volumeHistogram ? store.volumeHistogram!.total : 0,
      UnitKindEnum.VOLUME
    );

    const isQoeReady = !!(store.qoeHistogram && store.qoeHistogram.average);
    const peakQoeValue = unitsFormatter.format(isQoeReady ? store.qoeHistogram!.peakValue!.y : 0, UnitKindEnum.TRAFFIC);

    const isHitRateReady = !!store.hitRatePercent;
    const hitRateValue = unitsFormatter.format(isHitRateReady ? store.hitRatePercent! : 0, UnitKindEnum.PERCENT);
    return (
      <MetricsPanelView className={this.props.className}>
        <Header>
          <Title>world wide</Title>
          <SubTitle>last 24 hours by</SubTitle>
          <QwiltLogo size={16} />
          <MetricPanels>
            <MetricCard title={"total volume"} isReady={!!store.volumeHistogram} formattedValue={totalVolumeValue} />
            <MetricCard title={"peak bandwidth"} isReady={isBandwidthReady} formattedValue={peakBandwidthValue} />
            <MetricCard title={"avg bitrate"} isReady={isQoeReady} formattedValue={peakQoeValue} />
            <MetricCard title={"hit rate"} isReady={isHitRateReady} formattedValue={hitRateValue} />
          </MetricPanels>
        </Header>
        <ChartContainer>
          {isBandwidthReady ? (
            <QwiltHighchart chartConfig={store.bandwidthChartOptions} />
          ) : (
            <FallbackContainer>
              <LoadingSpinner />
              <LoadingMessage>Loading total traffic...</LoadingMessage>
            </FallbackContainer>
          )}
        </ChartContainer>
      </MetricsPanelView>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/metricsPanel/MetricsPanel.tsx